import React from "react";
// import { Link } from "react-router";
// import { PublicURL } from "../../../routes/public_routes/PublicURL";
import "../../../css/components/page_wrappers/common/Footer.css"

const Footer = () => {
    const brandName = process.env.REACT_APP_BRAND_NAME;

    return (
        <footer>
            <div className="footer-top container">
                <div className="row gy-4">
                    <div className="col-md-3">
                        <div className="footer-brand mb-3">{brandName}</div>
                        <p className="small">
                            Say goodbye to spreadsheets, manual errors and scattered financial data. Experience effortless finance management in one powerful platform.
                        </p>
                    </div>

                    <div className="col-6 col-md-3">
                        <div className="footer-title">Products</div>
                        <ul className="list-unstyled">
                        <li><a href="/">Edge network</a></li>
                        <li><a href="/">Application security</a></li>
                        <li><a href="/">Traffic acceleration</a></li>
                        <li><a href="/">Developer platform</a></li>
                        </ul>
                    </div>

                    <div className="col-6 col-md-3">
                        <div className="footer-title">Resources</div>
                        <ul className="list-unstyled">
                        <li><a href="/">Documentation</a></li>
                        <li><a href="/">API reference</a></li>
                        <li><a href="/">Status</a></li>
                        <li><a href="/">Community</a></li>
                        </ul>
                    </div>

                    <div className="col-6 col-md-3">
                        <div className="footer-title">Know More</div>
                        <ul className="list-unstyled">
                        <li><a href="/">Privacy Policy</a></li>
                        <li><a href="/">Data Protection</a></li>
                        <li><a href="/">About</a></li>
                        <li><a href="/">Terms & COnditions</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <div>© 2026 {brandName}. All rights reserved.</div>
                    <div className="social mt-3 mt-md-0">
                        <a href="/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter" viewBox="0 0 16 16">
                                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334q.002-.211-.006-.422A6.7 6.7 0 0 0 16 3.542a6.7 6.7 0 0 1-1.889.518 3.3 3.3 0 0 0 1.447-1.817 6.5 6.5 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.32 9.32 0 0 1-6.767-3.429 3.29 3.29 0 0 0 1.018 4.382A3.3 3.3 0 0 1 .64 6.575v.045a3.29 3.29 0 0 0 2.632 3.218 3.2 3.2 0 0 1-.865.115 3 3 0 0 1-.614-.057 3.28 3.28 0 0 0 3.067 2.277A6.6 6.6 0 0 1 .78 13.58a6 6 0 0 1-.78-.045A9.34 9.34 0 0 0 5.026 15"/>
                            </svg>
                        </a>
                        <a href="/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
